// extracted by mini-css-extract-plugin
export default {"overBackground":"MainPage_overBackground__g-bbe"};